import { getCustomerInfo, isStoreKitAvailable } from "../services/RevenueCatService";

/**
 * Checks if the user has an active subscription/membership
 * @returns Promise<boolean> - true if user has active membership, false otherwise
 */
export async function checkActiveMembership(): Promise<boolean> {
  if (!isStoreKitAvailable()) {
    return false;
  }

  try {
    const customerInfo = await getCustomerInfo();
    if (!customerInfo) {
      return false;
    }

    // Check activeSubscriptions array first
    // const activeSubscriptions = (customerInfo as any)?.activeSubscriptions as string[] | undefined;
    // if (activeSubscriptions && activeSubscriptions.length > 0) {
    //   console.log("[Subscription] Active subscription found:", activeSubscriptions[0]);
    //   return true;
    // }

    // Final fallback: Check entitlements for active subscriptions
    const entitlements = (customerInfo as any)?.entitlements?.active;
    if (entitlements && Object.keys(entitlements).length > 0) {
      console.log("[Subscription] Active entitlement found");
      return true;
    }

    return false;
  } catch (error) {
    console.error("[Subscription] Failed to check active membership", error);
    return false;
  }
}

